import React from 'react';
import PropTypes from 'prop-types';
import hoistStatics from 'hoist-non-react-statics';
import useTracker from 'lib/hooks/useTracker';

const withTracking = (Component) => {
  const WrappedComponent = (props) => {
    const tracker = useTracker();
    return <Component {...props} tracker={tracker} />;
  };

  WrappedComponent.displayName = `withTracking(${
    Component.displayName || Component.name
  })`;

  return hoistStatics(WrappedComponent, Component);
};

withTracking.TYPE = PropTypes.shape({
  track: PropTypes.func,
  identify: PropTypes.func,
  reset: PropTypes.func,
});

export default withTracking;
